// Public menu pages are slug-addressed at laddition.ma/menu/{city}/{name}.
// The public route (menu/:restaurant_city/:restaurant_name) turns each slug
// back into a display value with `replaceAll("-", " ")`, so we build the slug
// by reversing that: collapse whitespace runs into single dashes. Case is left
// untouched because the public lookup matches the name as-is.
const PUBLIC_MENU_BASE_URL = "https://laddition.ma";

const toSlug = (value: string) => value.trim().replace(/\s+/g, "-");

export const buildPublicMenuUrl = (name: string, city: string) =>
  `${PUBLIC_MENU_BASE_URL}/menu/${toSlug(city)}/${toSlug(name)}`;
